module.exports = __webpack_public_path__ + "img/Jinxed.10e356a2.png";